import cn from 'classnames';
import React from 'react';
import styles from './heading1.module.scss';

export interface TitleProps {
  bold?: boolean;
  color?: 'primary' | 'secondary' | 'green';
  children: any;
}

const Heading1: React.FC<TitleProps> = ({
  children,
  color = 'green',
  bold = false
}) => (
  <h1 className={cn(styles.heading1, styles[color], { [styles.bold]: bold })}>
    {children}
  </h1>
);

export default Heading1;
